module.exports = __webpack_public_path__ + "img/myPetComplete_cat.95e1d4ed.svg";